export const homePath = '/home';

export const invitePath = '/invite';

export const countDownPath = '/count-down';

export const dashboardPath = '/dashboard';
export const dashboardOverviewPath = '/dashboard/overview';
export const dashboardCapsulePath = '/dashboard/capsule';

export const luckyDrawPath = '/lucky-draw';

export const rankingPath = '/ranking';

export const userGuidePath = '/userguide';